const capitalizeWords = (inputString) => {
  if (inputString)
    return inputString
      .toLowerCase()
      ?.replace(/(^|\s)\S/g, (match) => match.toUpperCase());
};

export default capitalizeWords;
